<template>
    <div class="fill-height"  id="normal_order_cart">
        <v-overlay :value="isLoading">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <v-row class="fill-height my-0">
            <v-col cols="12" md="12" sm="12" class="py-0">
                <app-card class="fill-height d-flex flex-column py-0 topo" contentStyle="display: flex; flex-direction: column; height: 100%">
                    <template v-slot:title>
                        <v-card-title class="d-flex justify-space-between align-center title-text dark-blue-color mx-1">
                            {{ $t(titleKey, { id: normalOrderStore.getPendingCartId }) }}
                            <v-spacer></v-spacer>

                            <!-- <div class="d-flex justify-end">
                                <app-dialog :value="isHelpDialogOpen" @input="isHelpDialogOpen = $event" :title="$t('common.help')" width="40vw">
                                    <template v-slot:content></template>

                                    <template v-slot:buttons="{}">
                                        <v-btn text outlined class="myprovet-btn-cancel" @click="isHelpDialogOpen = false" data-cy="app-dialog-help-close-btn">{{ $t('common.close') }}</v-btn>
                                    </template>
                                </app-dialog>

                                <v-tooltip bottom open-on-hover content-class="myprovet-tooltip">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon v-bind="attrs" v-on="on" class="appbar-icon-button-small btn-bg-color-white dark-blue-color mr-1" style="cursor: pointer" data-cy="help-filter-card" @click.stop="isHelpDialogOpen = true"> mdi-help-circle-outline </v-icon>
                                    </template>

                                    <span>{{ $t('common.help') }}</span>
                                </v-tooltip>
                            </div> -->
                        </v-card-title>

                        <v-card-subtitle class="mx-1 pt-1" style="min-height: 42px">{{ $t(subtitleKey) }}</v-card-subtitle>
                    </template>

                    <template v-slot:content>
                        <shopping-cart class="d-flex flex-column fill-height" :hasItems="hasItems" :firstOrderDiscounts="firstOrderDiscounts" :account-blocked-message="accountBlockedMessage"></shopping-cart>

                        <v-row class="pt-2" v-if="hasItems">
                            <template v-if="!isPendingCart">
                                <v-col cols="12" md="6" sm="12"> </v-col>

                                <v-col cols="12" md="6" sm="12" >
                                    <v-row v-if="!isMobile">
                                        <v-col cols="12" md="4" sm="4">
                                            <v-btn text outlined class="myprovet-btn-cancel px-8" @click="goBack()" data-cy="go-back-btn">{{ $t('common.back') }}</v-btn>
                                        </v-col>

                                        <v-col cols="12" md="4" sm="4">
                                            <v-btn text outlined class="myprovet-btn-cancel px-8" @click="isEmptyCartDialogOpen = true">{{ $t('common.empty') }}</v-btn>
                                        </v-col>

                                        <v-col cols="12" md="4" sm="4">
                                            <v-btn text class="myprovet-btn-ok px-8" @click="confirmMinimumValue()" data-cy="cart-confirm-button">{{ $t('common.confirm') }}</v-btn>
                                        </v-col>
                                    </v-row>
                                    <v-row v-else>
                                        <v-col cols="6" md="4" class="col-xl-6">
                                            <v-btn text outlined class="myprovet-btn-cancel px-8 mb-4" @click="isEmptyCartDialogOpen = true">{{ $t('common.empty') }}</v-btn>
                                            <v-btn text outlined class="myprovet-btn-cancel px-8" @click="goBack()" data-cy="go-back-btn">{{ $t('common.back') }}</v-btn>
                                        </v-col>

                                        <v-col cols="6" md="4" class="col-xl-6">
                                            <v-btn text class="myprovet-btn-ok px-8 mt-11" @click="confirmMinimumValue()" data-cy="cart-confirm-button">{{ $t('common.confirm') }}</v-btn>

                                        </v-col>
                                    </v-row>
                                </v-col>
                            </template>
                            <template v-else>
                                <v-col cols="12" md="4" sm="4"></v-col>
                                <v-col cols="12" md="8" sm="8">
                                    <v-row>
                                        <v-col cols="12" md="1">
                                            <v-btn text outlined class="myprovet-btn-cancel px-8" @click="goBack()" data-cy="go-back-btn">{{ $t('common.back') }}</v-btn>
                                        </v-col>

                                        <v-col cols="12" md="4">
                                            <v-btn text outlined class="myprovet-btn-cancel px-8" @click="isDeletePendingCartDialogOpen = true">{{ $t('common.deleteCart') }}</v-btn>
                                        </v-col>

                                        <v-col cols="12" md="4">
                                            <v-btn text outlined class="myprovet-btn-cancel px-8" @click="isCancelPendingCartDialogOpen = true">{{ $t('common.cancelOperation') }}</v-btn>
                                        </v-col>

                                        <v-col cols="12" md="3">
                                            <v-btn text class="myprovet-btn-ok px-8" @click="confirmMinimumValue()" data-cy="cart-confirm-button">{{ $t('common.confirm') }}</v-btn>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </template>

                            <app-dialog :isConfirmationDialog="true"  :value="isCancelPendingCartDialogOpen" @input="isCancelPendingCartDialogOpen = $event" :title="$t('layout.attention')" :width="getEmptyCartDialogWidth">
                                <template v-slot:content>
                                    <p class="dark-blue-color pt-4" style="font-size: 16px">{{ $t('orders.cart.exitViewModeQuestion') }}</p>
                                </template>

                                <template v-slot:buttons>
                                    <v-btn text outlined class="myprovet-btn-cancel px-8" @click="isCancelPendingCartDialogOpen = false">{{ $t('common.cancel') }}</v-btn>
                                    <v-btn text class="myprovet-btn-ok px-8" @click="cancelPendingCart">{{ $t('common.exit') }}</v-btn>
                                </template>
                            </app-dialog>

                            <app-dialog :isConfirmationDialog="true"  :value="isEmptyCartDialogOpen" @input="isEmptyCartDialogOpen = $event" :title="$t('layout.attention')" :width="getEmptyCartDialogWidth">
                                <template v-slot:content>
                                    <p class="dark-blue-color pt-4" style="font-size: 16px">{{ $t('orders.cart.emptyCartQuestion') }}</p>
                                </template>

                                <template v-slot:buttons>
                                    <v-btn text outlined class="myprovet-btn-cancel px-8" @click="isEmptyCartDialogOpen = false">{{ $t('common.cancel') }}</v-btn>
                                    <v-btn text class="myprovet-btn-ok px-8" @click="clearCart">{{ $t('common.empty') }}</v-btn>
                                </template>
                            </app-dialog>

                            <app-dialog :isConfirmationDialog="true" :value="isDeletePendingCartDialogOpen" @input="isDeletePendingCartDialogOpen = $event" :title="$t('layout.attention')" :width="getEmptyCartDialogWidth">
                                <template v-slot:content>
                                    <p class="dark-blue-color pt-4" style="font-size: 16px">{{ $t('orders.cart.deletePendingQuestion') }}</p>
                                </template>

                                <template v-slot:buttons>
                                    <v-btn text outlined class="myprovet-btn-cancel px-8" @click="isDeletePendingCartDialogOpen = false">{{ $t('common.cancel') }}</v-btn>
                                    <v-btn text class="myprovet-btn-ok px-8" @click="deletePendingCart">{{ $t('common.delete') }}</v-btn>
                                </template>
                            </app-dialog>
                        </v-row>
                    </template>
                </app-card>
            </v-col>
        </v-row>

        <shipping-costs-dialog
            @input="isShippingCostsDialogOpen = $event"
            @try-open-pending-products-dialog="tryOpenPendingProductsDialog()"
            :isShippingCostsDialogOpen="isShippingCostsDialogOpen"
            :shippingCost="shippingCost"
            :branchShippingOfferValue="parseFloat(branchShippingOfferValue)"
            :shoppingCartSubtotal="parseFloat(shoppingCartSubtotal)"
        >
        </shipping-costs-dialog>

        <pending-products-dialog :isPendingProductsDialogOpen="isPendingProductsDialogOpen" @input="isPendingProductsDialogOpen = $event" :model="model" :schema="schema" :headers="headers" :details_headers="details_headers"></pending-products-dialog>
    </div>
</template>

<script>
import { mapStores } from 'pinia';
import { useUserStore } from '@/Stores/user';
import { useBranchStore } from '@/Stores/branch';
import { useNormalOrderStore } from '@/Stores/normalorder';
import { useAppStore } from '@/Stores/app';
import { axios } from '@/Services/Backend';
import MainLayout from './../../Layouts/MainLayout';

export default {
    layout: MainLayout,

    props: {
        accountBlockedMessage: String,
        firstOrderDiscounts: Array,
        zeroOrderLimit: Object,
        model: [Object, Array],
        schema: [Object, Array],
        headers: [Object, Array],
        details_headers: [Object, Array],
    },

    data: () => ({
        isLoading: false,

        isPendingCart: false,
        titleKey: 'cart.title',
        subtitleKey: 'orders.cart.subtitle',

        isHelpDialogOpen: false,

        isShippingCostsDialogOpen: false,

        isEmptyCartDialogOpen: false,
        isCancelPendingCartDialogOpen: false,
        isDeletePendingCartDialogOpen: false,

        isPendingProductsDialogOpen:false,

        shippingCost: {},
        shippingCostLoaded: false,
        branchShippingOfferValue: 0,
    }),

    watch: {
        shippingCostLoaded: {
            handler: function (loaded) {
                this.shippingCostLoaded = false;
                if (loaded) this.confirmOrder();
            },
            immediate: true,
        },
        'normalOrderStore.getPendingCartId': {
            handler: function (pendingCartId) {
                // Watch the id and not the status, as the id can change without a status change
                if (pendingCartId && pendingCartId > -1) {
                    this.titleKey = 'cart.pendingTitle';
                    this.subtitleKey = 'orders.cart.subtitlePending';
                    this.isPendingCart = true;
                } else {
                    this.titleKey = 'cart.title';
                    this.subtitleKey = 'orders.cart.subtitle';
                    this.isPendingCart = false;
                }
            },
            immediate: true,
        },
    },

    computed: {
        ...mapStores(useUserStore, useBranchStore, useNormalOrderStore,useAppStore),

        hasItems() {
            return this.normalOrderStore.getProductCount > 0 || this.normalOrderStore.getCampaignCount > 0;
        },
        shoppingCartSubtotal() {
            return this.normalOrderStore.getCartSubtotal;
        },

        firstOrderDiscount: {
            get() {
                return this.normalOrderStore.getFirstOrderDiscount;
            },
            set(value) {
                this.normalOrderStore.setFirstOrderDiscount(value);
            },
        },
        getEmptyCartDialogWidth() {
            return this.getResponsiveDialogWidth('60vw', '35vw');
        },
        isMobile(){
            return this.appStore.mobile_ls?false:this.appStore.is_mobile;
        },
        isExternalSeller(){
            return this.userStore.hasPermissionTo('Only list products of the associated seller\'s laboratories')
        }
    },

   /* mounted() {
        window.EventBus.$emit('refresh-shared-cart');
    },*/

    methods: {
        goBack() {
            this.$inertia.visit('/dashboard');
        },
        deletePendingCart() {
            const targetCartId = this.normalOrderStore.getPendingCartId;

            axios
                .delete('/api/orders/pending-carts/' + targetCartId)
                .then(() => {
                    this.isDeletePendingCartDialogOpen = false;
                    this.normalOrderStore.clearCartAndNotify({ showMessage: false, sendSharedCart: false });
                    window.EventBus.$emit('refresh-pending-carts');

                    if (window.location.pathname.startsWith('/orders/normal/cart')) {
                        this.$inertia.visit('/orders/normal');
                        return;
                    }
                    this.showSuccess(this.$t('orders.cart.pendingDeleted'));
                    window.EventBus.$emit('refresh-shared-cart', { leavingPendingCartMode: true });
                    window.EventBus.$emit('refresh-shared-cart-subscription', {});

                    if (window.location.pathname.startsWith('/orders/normal/cart')) {
                        this.$inertia.visit('/orders/normal');
                        return;
                    }
                })
                .catch((error) => {
                    this.showError(this.$t('orders.cart.deletePendingError'));
                    this.isDeletePendingCartDialogOpen = false;
                });
        },

        clearCart() {
            this.normalOrderStore.clearCartAndNotify({});

            if (window.location.pathname.startsWith('/orders/normal/cart')) {
                this.$inertia.visit('/orders/normal');
                return;
            }

            this.isEmptyCartDialogOpen = false;
        },

        cancelPendingCart() {
            this.isCancelPendingCartDialogOpen = false;
            this.normalOrderStore.clearCartAndNotify({ showMessage: false, sendSharedCart: false });
            window.EventBus.$emit('refresh-shared-cart', { leavingPendingCartMode: true });
            window.EventBus.$emit('refresh-shared-cart-subscription', {});

            if (window.location.pathname.startsWith('/orders/normal/cart')) {
                this.$inertia.visit('/orders/normal');
                return;
            }
        },

        confirmMinimumValue() {
            this.isLoading = true;

            const branch_id = this.branchStore.branch?.id;
            const products = this.normalOrderStore.getProducts.map((product) => {
                // If a product has an substitute set, we'll want to send the substitute.
                if (product.selected_substitute_product) {
                    // There are fields that must be moved over to the new product.
                    product.selected_substitute_product.quantity = product.quantity;
                    product.selected_substitute_product.observation = product.observation;

                    return product.selected_substitute_product;
                }

                return product;
            });

            // TODO: Send the campaigns if Propec realize that for the zero order we need to add the shipping cost with the order total value.
            axios.post('/api/orders/shipping-cost-info', { branch_id: branch_id, products: products }).then((response) => {
                this.isLoading = false;

                this.branchShippingOfferValue = response.data?.branchShippingOfferValue;
                this.shippingCost = response.data?.shippingCost;
                this.shippingCostLoaded = true;
            });
        },
        checkIfCanSelectLabOrder(){
            let rs=false
             let labs=[]
               _.each(this.normalOrderStore.getProducts,(o)=>{
                    let index= _.indexOf(labs,o.laboratory_id)
                    if(index==-1){
                        labs.push(o.laboratory_id)
                    }
                 })
               if(_.size(labs)>1){
                //this.$nextTick(_=>{
                  //  this.additionalInfo[2].disabled=true
                //})
                //this.ckLaboratoryOrder=false
                rs= true
               }
            return rs
        },
        confirmOrder() {
            if (!this.hasItems) {
                this.$inertia.visit('/orders/normal');
                return;
            }
            if (this.normalOrderStore.isLaboratoryOrder && this.checkIfCanSelectLabOrder()) {
                this.showError(this.$t('orders.cart.labMixError'));
                return;
            }
            if (this.normalOrderStore.getDeliveryAddress === null || this.normalOrderStore.getDeliveryAddress.address === undefined) {
                this.showError(this.$t('orders.cart.deliveryAddressRequired'));
                return;
            }

            // Informação adicional
            if (this.normalOrderStore.isBudgetRequest && (this.normalOrderStore.isScheduledOrder || this.normalOrderStore.isLaboratoryOrder || this.normalOrderStore.isFirstOrder)) {
                this.showError(this.$t('orders.cart.quoteConflict'));
                return;
            }

            if (this.normalOrderStore.isScheduledOrder && !this.normalOrderStore.getScheduledOrderDate) {
                this.showError(this.$t('orders.cart.invalidScheduleDate'));
                return;
            }

            if (this.normalOrderStore.isFirstOrder) {
                if (!this.normalOrderStore.getFirstOrderDiscount?.percentage) {
                    this.showError(this.$t('orders.cart.firstOrderDiscountRequired'));
                    return;
                }
            }

            if (this.shippingCost && this.shoppingCartSubtotal < this.branchShippingOfferValue) {
                if (!this.isOrderZero()) {
                    this.isShippingCostsDialogOpen = true;
                    return;
                }
            }

            // Check if the client has pending products and accept_pending == true to show pending products dialog
            if (this.branchStore.hasPendingProducts && this.branchStore.branch.accept_pending === true && !this.isExternalSeller) {
                this.isPendingProductsDialogOpen = true;
                return;
            }

            const client_number = this.branchStore.branch?.client_number;
            const company_branch = this.branchStore.branch?.company_branch;

            this.$inertia.visit(`/orders/normal/summary/${client_number}/${company_branch}`);
        },

        tryOpenPendingProductsDialog() {
            this.isShippingCostsDialogOpen = false;

            // Check if the client has pending products and accept_pending == true to show pending products dialog
            if (this.branchStore.hasPendingProducts && this.branchStore.branch.accept_pending === true && !this.isExternalSeller) {
                this.isPendingProductsDialogOpen = true;
            } else {
                const client_number = this.branchStore.branch?.client_number;
                const company_branch = this.branchStore.branch?.company_branch;

                this.$inertia.visit(`/orders/normal/summary/${client_number}/${company_branch}`);
            }
        },

        isOrderZero() {
            if (!this.userStore.hasPermissionTo('Finish orders')) return false;
            if (!this.userStore.hasPermissionTo('Access zero orders')) return false;
            if (!this.branchStore.branch?.has_zero_order) return false;
            if (this.normalOrderStore.isBudgetRequest) return false;
            if (!this.zeroOrderLimit) return false;
            if (this.branchStore.branch?.zone === 'ILHAS') return false;

            let total = this.normalOrderStore.getCartTotal ?? 0;
            return this.zeroOrderLimit.active && this.zeroOrderLimit.value > 0 && total > 0 && total <= this.zeroOrderLimit.value;
        },
    },
};
</script>

<style>
div#shopping-cart-form div.v-select__slot label.v-label,
div#shopping-cart-form div.v-text-field__slot label.v-label {
    font-size: 0.75rem !important;
    line-height: 25px !important;
    color: #154579 !important;
}

div#shopping-cart-form div.v-select__slot div.v-select__selections div.v-select__selection {
    font-size: 0.75rem !important;
    line-height: 14px !important;
    color: #154579 !important;
}
</style>
